import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {

    const session = getUserSession();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();
    const profileFilter = chooseProfileFilter();

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    if (profileFilter.pdc_company_id) {
        hiddenValues.pdc_company_id = profileFilter.pdc_company_id
    }

    const path = '/workplancategories/';
    const paths = {
        endpointSave: config.endpoints.backend + 'workplancategories/save',
        endpointGetById: config.endpoints.backend + 'workplancategories/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova categoria do plano de trabalho",
        labelTitleEdit: "Editar categoria do plano de trabalho",
        labelTitleView: 'Visualizar categoria do plano de trabalho'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                !hiddenValues.pdc_company_id && !hiddenValues.pdc_entity_id && !profileFilter.pdc_project_ids ? {
                    name: 'pdc_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        values.pdc_entity_id = '';
                        values.pdc_project_id = '';
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                } : {},
                !hiddenValues.pdc_entity_id && !hiddenValues.pdc_entity_id && !profileFilter.pdc_project_ids ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_company_id: !!values.pdc_company_id ? values.pdc_company_id : !!profileFilter.pdc_company_id ? profileFilter.pdc_company_id : null
                            }
                        }
                    },
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        values.pdc_project_id = '';
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_company_id: !!values.pdc_company_id ? values.pdc_company_id : !!profileFilter.pdc_company_id ? profileFilter.pdc_company_id : null,
                                pdc_entity_id: !!values.pdc_entity_id ? values.pdc_entity_id : !!profileFilter.pdc_entity_id ? profileFilter.pdc_entity_id : null
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'note',
                    type: 'textarea',
                    label: 'Observação',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
